import { render, staticRenderFns } from "./SkupTemaEdit.vue?vue&type=template&id=7119641a&scoped=true&"
import script from "./SkupTemaEdit.vue?vue&type=script&lang=js&"
export * from "./SkupTemaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7119641a",
  null
  
)

export default component.exports